module.exports = __webpack_public_path__ + "img/ligas-melhor.53cf97e8.png";